module.exports = __webpack_public_path__ + "media/images/client/favicons/apple-touch-icon-120x120-25588ac9383aec83a5be7a8a9f568e0d.png";